module.exports = __webpack_public_path__ + "assets/img/dec-black-paper.0f96a305.png";